import { AiOutlineMergeCells, AiOutlineNodeIndex, AiOutlineStop } from "react-icons/ai";
import { MdCompareArrows, MdGroups, MdIosShare, MdLink, MdLockOpen, MdLogin, MdOpenInNew, MdOutlineAccountTree, MdOutlineCloudDone, MdOutlineMailLock, MdOutlineMarkEmailRead, MdOutlinePassword, MdOutlineSecurity } from "react-icons/md";

//  Page Title: Single Sign-On
export const ssoData = [
    {
        text: "Auto Redirect from site",
        video: true,
        videoId: "nyxWvDGc3mU",
        videoType: "youtube",
        icon: <MdOpenInNew className='text-white fs-5' />
    },
    {
        text: "Auto Redirect from WP Login",
        video: true,
        videoId: "-E4yqvxJ6qw",
        videoType: "youtube",
        icon: <MdIosShare className='text-white fs-5' />
    },
    {
        text: "Login using SSO button on wp-login",
        video: true,
        videoId: "LDcCkhaE6cA",
        videoType: "youtube",
        icon: <MdLogin className='text-white fs-5' />
    },
    {
        text: "Login using the SSO link on the site",
        video: true,
        videoId: "G3uEUhXp8Fc",
        videoType: "youtube",
        icon: <MdLink className='text-white fs-5' />
    },
    {
        text: "Role Mapping Based on User Group Attributes",
        video: true,
        videoId: "yyg0TjZ4iao",
        videoType: "youtube",
        icon: <MdGroups className='text-white fs-5' />
    },
    {
        text: "Restricting specific pages behind SSO",
        video: true,
        videoId: "jt412h2_nL4",
        videoType: "youtube",
        icon: <AiOutlineStop className='text-white fs-5' />
    },
    {
        text: "SSO Login based on Email Domains",
        video: true,
        videoId: "sQ3nxgn5FZk",
        videoType: "youtube",
        icon: <MdOutlineMarkEmailRead className='text-white fs-5' />
    },
    {
        text: "SSO Login Restriction based on Email Domains",
        video: true,
        videoId: "kx7OuN2xq94",
        videoType: "youtube",
        icon: <MdOutlineMailLock className='text-white fs-5' />
    },
    {
        text: "SSO between two WordPress sites",
        video: true,
        videoId: "p9W4bnRgHUQ",
        videoType: "youtube",
        icon: <MdCompareArrows className='text-white fs-5' />
    },
    {
        text: "SSO for multi-site environment",
        video: true,
        videoId: "GPuhyLnNvh8",
        videoType: "youtube",
        icon: <MdOutlineAccountTree className='text-white fs-5' />
    },
    {
        text: "Single Sign-On Setup using SAML",
        video: true,
        videoId: "9vT2oKcPYVE",
        videoType: "youtube",
        icon: <MdLockOpen className='text-white fs-5' />
    },
    {
        text: "SSO using OAuth Authorization Code Grant Type",
        video: true,
        videoId: "zG4GGmCl0aI",
        videoType: "youtube",
        icon: <AiOutlineMergeCells className='text-white fs-5' />
    },
    {
        text: "SSO Setup using PKCE Grant Type Flow",
        video: true,
        videoId: "026wAyDMdH4",
        videoType: "youtube",
        icon: <AiOutlineNodeIndex className='text-white fs-5' />
    },
    {
        text: "SSO Setup using Password Grant Type Flow",
        video: true,
        videoId: "Amg4Re5IWPo",
        videoType: "youtube",
        icon: <MdOutlinePassword className='text-white fs-5' />
    },
    {
        text: "SSO Setup using JWT Grant Type Flow",
        video: true,
        videoId: "FBgUvHUZfrI",
        videoType: "youtube",
        icon: <MdOutlineCloudDone className='text-white fs-5' />
    },
    {
        text: "Protect Complete Site Setup with OAuth SSO",
        video: true,
        videoId: "R5QHGqmb8zc",
        videoType: "youtube",
        icon: <MdOutlineSecurity className='text-white fs-5' />
    }
]